export const TRANSLATIONS_VERSION = 'translation-version';
export const USER_PLATFORM_HEADER = 'user-platform';
export const AUTHORIZATION_HEADER = 'X-Authorization';
